import { render, staticRenderFns } from "./NewMessengerConversationInput.vue?vue&type=template&id=612b012c&scoped=true"
import script from "./NewMessengerConversationInput.vue?vue&type=script&lang=js"
export * from "./NewMessengerConversationInput.vue?vue&type=script&lang=js"
import style0 from "./NewMessengerConversationInput.vue?vue&type=style&index=0&id=612b012c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612b012c",
  null
  
)

export default component.exports